import { render, staticRenderFns } from "./EditReproductions.vue?vue&type=template&id=664f43d4&scoped=true&"
import script from "./EditReproductions.vue?vue&type=script&lang=ts&"
export * from "./EditReproductions.vue?vue&type=script&lang=ts&"
import style0 from "./EditReproductions.vue?vue&type=style&index=0&id=664f43d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f43d4",
  null
  
)

export default component.exports